import React, { useRef } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { getColor, lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import { ReactComponent as PencelSvgIcon } from '../../../image/BlackPencel.svg';
import { ReactComponent as ExitSvgIcon } from '../../../image/BlackExit.svg';
import { ReactComponent as DownArrowSvgIcon } from '../../../image/DownArrow.svg';

export default function CategoryBox(props) {
  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const {
    data,

    // 움직임 //
    index,
    dataListLength,
    target,
    targetStartY,
    targetEndY,
    emptyHeight,
    clickIndex,
    changedIndex,
    setChangedIndex,
    clickDivision,
    isNotClick,
    setIsNotClick,
    onMouseDown,
    onClickChangeIndex,
    // 움직임 //

    setClickLessonData,
    isClickedLessonEdit,
    onClickEditLessonButton,
    onClickDeletedLesson
  } = props;

  const TotalRef = useRef();
  const EmptyRef = useRef();

  // // 움직임 정리 //
  // useEffect(() => {
  //   if (TotalRef === null
  //     || target === TotalRef.current
  //     || changedIndex === undefined
  //     || targetStartY === 0
  //     || targetEndY === 0) {
  //     TotalRef.current.style.transform = `translateY(0px)`;
  //     TotalRef.current.style.transition = `none`;

  //     return;
  //   }

  //   // 현재 컴포넌트 시작 좌표 //
  //   var myStartY = TotalRef.current.getBoundingClientRect().top;
  //   // 컴포넌트 크기 //
  //   // var myHeight = TotalRef.current.offsetHeight;
  //   // let myHeight = 67;
  //   let myHeight = 52;
  //   // 현재 컴포넌트 끝 좌표 //
  //   var myEndY = myEndY + myHeight;
  //   // 컴포넌트 움직임을 결정할 기준점 //
  //   var standardY = (myStartY + (myHeight / 2));
  //   // 타겟 컴포넌트의 기준점 ( 정중앙 ) //
  //   var targetStandardY = ((targetStartY + targetEndY) / 2);

  //   // 움직임 에니메이션 주기 //
  //   TotalRef.current.style.transition = `all 0.3s ease-in-out`;

  //   // 타겟이 움직여야할 컴포넌트보다 아래에 있을 경우 //
  //   if (clickIndex > index) {
  //     // 가동 범위 내에 있는지 확인 //
  //     if (myStartY < targetStandardY || targetStandardY < myEndY) {
  //       // 타겟의 기준점이 움직임 기준점을 넘기면 이동
  //       if (targetStandardY < standardY) {
  //         TotalRef.current.style.transform = `translateY(${targetEndY - targetStartY + 15}px)`;
  //         setChangedIndex(index);
  //       }
  //       else if (targetStandardY > standardY) {
  //         TotalRef.current.style.transform = `translateY(0px)`;
  //         setChangedIndex(index === dataListLength - 1 ? dataListLength : index + 1);
  //       }
  //     }
  //   }
  //   // 타겟이 움직여야할 컴포넌트보다 위에 있을 경우 //
  //   else if (clickIndex < index) {
  //     // 가동 범위 내에 있는지 확인 //
  //     if (myStartY < targetStandardY || targetStandardY < myEndY) {
  //       if (targetStandardY > standardY) {
  //         TotalRef.current.style.transform = `translateY(-${targetEndY - targetStartY + 15}px)`;
  //         setChangedIndex(index);
  //       }
  //       // 다시 위로 올라갈경우 제자리로 //
  //       else if (targetStandardY < standardY) {
  //         TotalRef.current.style.transform = `translateY(0px)`;
  //         setChangedIndex(index === 0 ? 0 : index - 1);
  //       }
  //     }
  //   }
  // }, [TotalRef, target, targetStartY, targetEndY, clickDivision, clickIndex, changedIndex, index, dataListLength])

  // 카테고리 클릭시 //
  function onClickLesson() {
    if (isNotClick) return;

    setClickLessonData(data);
  }

  // 카테고리 수정 클릭시 //
  function onClickEditLesson(e) {
    e.stopPropagation();
    if (isNotClick) return;

    onClickEditLessonButton(data);
  }

  // 이동(동작 번호 및 동작 이름) 버튼 클릭시 //
  function onComponentMouseDown(e) {
    onMouseDown(e, TotalRef.current, index);
  }

  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('DOWN', index);
  }

  return (
    <TopLevelWrapper>
      { (target === TotalRef.current && target !== undefined) && <EmptyBox ref={EmptyRef} height={emptyHeight} /> }
      <LessonBoxView
        ref={TotalRef}
        // onMouseDown={onComponentMouseDown}
        onClick={onClickLesson}
        isHide={data.isHide}
        hoverColor={isClickedLessonEdit ? '' : getColor(data.color, isDark)}
        isUnvisible={true}
        $isDark={isDark}>
        {data.isHide && (
          <DashedBorderSvg viewBox="0 0 500 54" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="498.5" height="52.5" rx="11.25" ry="11.25" fill="none" stroke={theme.line} strokeWidth="1.5" strokeDasharray="6 8" />
          </DashedBorderSvg>
        )}
        <TextWrapper>
          <ArrowWrapper>
            <ArrowImageWrapper onClick={onClickMoveUp}>
              <StyledUpArrowSvg />
            </ArrowImageWrapper>
            <ArrowImageWrapper onClick={onClickMoveDown}>
              <StyledDownArrowSvg />
            </ArrowImageWrapper>
          </ArrowWrapper>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} cursor='pointer'>{data.name}</Text>
        </TextWrapper>
        <StatusWrapper>
          {
            data.isHide && <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.line} cursor='default'>{t('system.private')}</Text>
          }
          <ImageWrapper>
            <StyledPencilIcon style={{ color: theme.line }} onClick={onClickEditLesson} />
            <StyledCloseIcon style={{ color: theme.line }} onClick={(e) => { e.stopPropagation(); onClickDeletedLesson(data); }} />
          </ImageWrapper>
        </StatusWrapper>
      </LessonBoxView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 495px;
  // height: 52px;
  // min-height: 52px;
`;

const LessonBoxView = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 16px 0px 16px;
  margin: 7.5px 0px 7.5px 0px;

  width: 463px;
  height: 52px;
  min-height: 52px;

  color: ${props => props.theme.text};

  border-radius: 12px;
  border: 1.5px solid transparent;
  background-color: ${props => props.isHide ? props.theme.buttonFill : props.theme.subBackground};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.03);

  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${props => props.isUnvisible ? props.theme.text : `#FFFFFF`};
    background-color: ${props => props.hoverColor};
    cursor: pointer;
  }
`;

const DashedBorderSvg = styled.svg`
  position: absolute;
  top: -1px;
  left: -18.5px;
  width: calc(100% + 37px);
  height: calc(100% + 2px);
  pointer-events: none;
`;

const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: ${props => props.height === 0 ? `0px 0px 0px 0px` : `7.5px 0px 7.5px 0px`};

  width: 463px;
  // height: 52px;
  // min-height: 52px;
  height: ${props => props.height}px;
  min-height: ${props => props.height}px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 77.75%;

  gap: 15px;

  overflow: hidden;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color || props.theme.text};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;
`;

const StyledPencilIcon = styled(PencelSvgIcon)`
  width: 20px;
  height: 20px;

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const StyledCloseIcon = styled(ExitSvgIcon)`
  width: 20px;
  height: 20px;

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledUpArrowSvg = styled(DownArrowSvgIcon)`
  width: 18px;
  height: auto;

  color: ${props => props.theme.line};

  transform: rotate(180deg);

  transition: color 0.3s ease-in-out;

  ${LessonBoxView}:hover & {
    color: ${props => props.theme.white};
  }
`;

const StyledDownArrowSvg = styled(DownArrowSvgIcon)`
  width: 18px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;

  ${LessonBoxView}:hover & {
    color: ${props => props.theme.white};
  }
`;
